// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ps-0";
export var animationContainer = "_ps-1";
export var itemPrice = "_ps-a";
export var itemizedContent = "_ps-9";
export var itemizedHeader = "_ps-7";
export var itemizedRow = "_ps-8";
export var itemizedSection = "_ps-6";
export var modalContent = "_ps-2";
export var orderName = "_ps-3";
export var refundOption = "_ps-4";
export var refundOptionsContainer = "_ps-5";
export var shippingLabel = "_ps-b";
export var totalRow = "_ps-c";